import { useEffect } from 'react';

import isEmpty from 'lodash/isEmpty';

import { selectMnvvChannelId, selectMnvvError, selectMnvvReservationNumber } from '@/ducks/mnvv/selectors';
import { FlowType } from '@/features/flowType/types';
import useFlowType from '@/features/flowType/useFlowType';
import { type TRedirectConfig, type TRouteConfig } from '@/features/routeConfig/types';
import { useAppSelector } from '@/store';
import { type TOptional } from '@/types/common';

const useDetectForeignMnvv = (routeConfig: TOptional<TRouteConfig>, onDetect: (redirect: TRedirectConfig) => void) => {
  const redirectConfig = routeConfig?.nonAuthMnvv;
  const {
    flowParams: { [FlowType.MNVV]: params },
    isMNVV,
  } = useFlowType();
  const isApplicable = isMNVV && !!redirectConfig?.redirectTo;
  const error = useAppSelector(selectMnvvError);
  const channelId = useAppSelector(selectMnvvChannelId);
  const reservationNumber = useAppSelector(selectMnvvReservationNumber);

  useEffect(() => {
    if (isApplicable && (!isEmpty(error) || (channelId && reservationNumber !== params.reservationNumber)))
      onDetect(redirectConfig);
  }, [channelId, error, reservationNumber]);
};

export default useDetectForeignMnvv;
